// this is an autogenerated file from App/Account/Content/Tasks/New/Content/Board/Content/Main/Subscribers/Content/EmployeeTable/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Tasks_New_Content_Board_Content_Main_Subscribers_Content_EmployeeTable($board_id: uuid!) {
  tasks_subscribers(
    where: { board_id: { _eq: $board_id } }
    order_by: [{ user: { vaxiom_person: { first_name: asc } } }]
  ) {
    id
    created_at
    created_by
    created_by_user {
      id
      vaxiom_person {
        _id
        first_name
        last_name
      }
    }
    user_id
    user {
      id
      account {
        id
        email
      }
      vaxiom_person {
        _id
        first_name
        last_name
      }
    }
    stage {
      id
      name
      order
    }
  }
}

`